import { Directive, TemplateRef, ViewContainerRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Store } from '@ngxs/store'
import { distinctUntilChanged } from 'rxjs'
import { UserState } from '../store'

/**
 * This directive shows or hides an element based on whether the user is a global admin
 */
@Directive({
  selector: '[ifGlobalAdmin]',
  standalone: true,
})
export class IfGlobalAdminDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store,
  ) {
    this.store
      .select(UserState.isGlobalAdmin)
      .pipe(distinctUntilChanged(), takeUntilDestroyed())
      .subscribe(isGlobalAdmin => {
        if (isGlobalAdmin) {
          this.viewContainer.createEmbeddedView(this.templateRef)
        } else {
          this.viewContainer.clear()
        }
      })
  }
}
